import type { CreateOnboardingLinkResponse } from '@services/api/types';

import { useApi } from './api/useApi';
import { useOrganizationApi } from './api';

type Options = {
  onSuccess?: (data: CreateOnboardingLinkResponse) => void;
  organizationId?: string;
  vendorNameId?: string;
};

export default function useOrganizationCreateOnboardingLink({
  onSuccess,
  organizationId,
  vendorNameId,
}: Options = {}) {
  const api = useOrganizationApi();

  const { data, execute, isExecuting } = useApi<
    CreateOnboardingLinkResponse,
    void
  >({
    request: () => api.createOnboardingLink(organizationId, vendorNameId),
    showSnackbar: false,
    onSuccess,
  });

  return {
    isFetching: isExecuting,
    createLink: execute,
    onboardingLink: data ?? ({} as CreateOnboardingLinkResponse),
  };
}
